import type React from "react";
import { createContext, useContext, useState } from "react";

const PointsContext = createContext({
	points: 0,
	addPoints: (points: number) => {
		console.log("Adding points:", points);
	},
	setPoints: (points: number) => {
		console.log("Setting points:", points);
	},
});

export const PointsProvider = ({ children }: { children: React.ReactNode }) => {
	const [points, setPoints] = useState(0);

	const addPoints = (pointsToAdd: number) => {
		setPoints((prevPoints) => prevPoints + pointsToAdd);
	};

	return (
		<PointsContext.Provider value={{ points, addPoints, setPoints }}>
			{children}
		</PointsContext.Provider>
	);
};

export const usePoints = () => useContext(PointsContext);
